import React from 'react'
import ToastMessageStyled from './styled-components/ToastMessageStyled'
import styled from 'styled-components'

const DismissButton = styled.span`
  color: ${props => props.theme.colors.orange};
  font-size: ${props => props.theme.fontSizeExtraSmall};
  font-weight: 600;
`

const ToastMessage = (props) => {
  return (
    <ToastMessageStyled data-toast-message>
      <span>
        {props.messageText}
      </span>
      &nbsp;
      <DismissButton onClick={props.dismissToastMessage} data-dismiss-button>
        Dismiss
      </DismissButton>
    </ToastMessageStyled>
  )
}

export default ToastMessage
